import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {
      id: "",
      quantity: 0,
      manufacturer: "",
      model: "",
      groupId: "",
      organizationId: "",
      serialNumbers: []

  },
  allGroupDevices: [],
  assignmentData: {
    groupName: "",
    totalDevices: 0,
    deviceName: "",
    groupDeviceId: 0,
    serialNums: []
  },
  updating: false,
};

const deviceManagmentSlice = createSlice({
  name: 'deviceManagement',
  initialState,
  reducers: {
    resetDeviceState: (state) => {
      Object.assign(state, initialState);
    },
    setUpdatingDevice(state, action) {
      state.data = action.payload;
      state.updating = true;
    },
    setAssignmentData(state, action) {
      state.assignmentData = action.payload;
    },
    setAllGroupDevices(state, action) {
      state.allGroupDevices = action.payload;
    }
  },
});

export const {
    resetDeviceState,
    setUpdatingDevice,
    setAssignmentData,
    setAllGroupDevices
} = deviceManagmentSlice.actions;

export default deviceManagmentSlice.reducer;
